import { supertypeClass, property } from '@haventech/amorphic';
import { BaseQuote } from '../../../common/js/quote/BaseQuote';

@supertypeClass({ toClient: true, toServer: true })
export abstract class ClientBaseQuote extends BaseQuote {
  @property({
    rule: ['numeric', 'required'],
    values: ['10', '20', '30'],
    descriptions: {
      '10': '10',
      '20': '20',
      '30': '30',
    },
  })
  term: number;

  @property({
    comment: 'Gender of the individual. Domain of Values {"1": "Male", "2": "Female"}',
    values: ['1', '2'],
    descriptions: { '1': 'Male', '2': 'Female' },
  })
  gender: '1' | '2';

  @property({
    values: { '0': 'excellent health', '1': 'very good health', '2': 'good health', '3': 'average health' },
  })
  healthClassNumber: number = 0;

  @property({ values: { false: 'do not', true: 'do' } })
  smoker: boolean;

  @property({
    rule: ['DOB', 'required'],
    validate: 'isDOBWithin(18,64)',
    sensitiveData: true,
    comment: 'Date of Birth of the Individual/Person',
  })
  dateOfBirth: Date;

  @property({
    comment: 'the type of product, term',
  })
  productType: 'Whole' | 'Term' | 'Annuity' = 'Term';

  @property({
    comment: `amount of death benefit an individual can receive`,
    rule: ['currency', 'required'],
  })
  faceAmount: number;

  @property({
    toServer: false,
    rule: 'required',
  })
  ownerEqualsInsured: boolean;

  @property({
    rule: 'required',
  })
  carrierCode: string;

  @property({
    rule: 'required',
  })
  waiverOfPremium: boolean = false;

  // Checks if all properties necessary to get a quote are present
  verifyProperties(): boolean {
    return (
      this.gender &&
      this.healthClass &&
      this.dateOfBirth &&
      this.contractState &&
      this.term &&
      this.faceAmount &&
      typeof this.waiverOfPremiumAmount !== 'undefined' &&
      typeof this.waiverOfPremium !== 'undefined'
    );
  }
}
